export type Theme = "light" | "dark";
const KEY = "manufacture-theme";

export function getTheme(): Theme {
  return localStorage.getItem(KEY) === "dark" ? "dark" : "light";
}

export function setTheme(theme: Theme): void {
  localStorage.setItem(KEY, theme);
  document.documentElement.dataset.theme = theme;
  document.documentElement.classList.toggle("dark", theme === "dark");
  document.querySelector<HTMLMetaElement>('meta[name="theme-color"]')?.setAttribute(
    "content",
    theme === "dark" ? "#0f172a" : "#f8fafc",
  );
  window.dispatchEvent(new CustomEvent("manufacture-theme", { detail: theme }));
}

export function initializeTheme(): Theme {
  const theme = getTheme();
  document.documentElement.dataset.theme = theme;
  document.documentElement.classList.toggle("dark", theme === "dark");
  return theme;
}
